import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export enum PermissionGroupEnum {
  ADMIN = 'ADMIN',
  USER = 'USER'
}
export class IPostUserVendorPermissionsBodyDto {
  userId: number;
  vendorId: number;
  permissionGroup: PermissionGroupEnum;
}

export class IPatchUserVendorPermissionsBodyDto {
  vendorId: number;
  permissionGroup: PermissionGroupEnum;
}

export class UserVendorPermission {
  id: number;
  userId: number;
  vendorId: number;
  permissionGroup: PermissionGroupEnum;
}

export class IUserVendorPermissionResponse {
  @Type(() => UserVendorPermission)
  result: UserVendorPermission;
}

export class IUserVendorPermissionListResponse extends IPagination {
  @Type(() => UserVendorPermission)
  results: UserVendorPermission[];
}

export class IUserVendorpermissionsQueryDto extends IQueryPaginationDto {
  userId?: string;
}
